import { useEffect, useState } from 'react'

interface Props {
  message: string
  onClose: () => void
}

export function Toast({ message, onClose }: Props) {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false)
      onClose()
    }, 4000)
    return () => clearTimeout(t)
  }, [onClose])

  if (!visible) return null
  return (
    <div className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white shadow-lg">
      {message}
    </div>
  )
}
